import { green, grey, red, yellow } from '@mui/material/colors';
import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';
import { SITUACAO_VOTO } from './SituacaoVoto';

/**
 * Enum para tipos de voto.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const TIPO_VOTO = {
    CONVERGENTE              : { id: 'CONVERGENTE',              descricao: 'Convergente',        codigo: 1, cor: green[800]  },
    DIVERGENTE               : { id: 'DIVERGENTE',               descricao: 'Divergente',         codigo: 2, cor: red[900]    },
    CONVERGENTE_COM_RESSALVA : { id: 'CONVERGENTE_COM_RESSALVA', descricao: 'Confirmado',         codigo: 3, cor: yellow[800] },
    CONVERGENTE_TACITO       : { id: 'CONVERGENTE_TACITO',       descricao: 'Convergente tácito', codigo: 4, cor: green[800]  },
    RELATOR                  : { id: 'RELATOR',                  descricao: 'Relator',            codigo: 5, cor: green[800]  },
    AUSENTE                  : { id: 'AUSENTE',                  descricao: 'Ausente',            codigo: 6, cor: grey[900]   },
    IMPEDIDO                 : { id: 'IMPEDIDO',                 descricao: 'Impedido',           codigo: 7, cor: red[900]    },
    //POSSIVELMENTE_IMPEDIDO   : { id: 'POSSIVELMENTE_IMPEDIDO',   descricao: 'Possivelmente impedido',codigo: 9, cor: orange[700] },
    CADEIRA_JA_VOTOU         : { id: 'CADEIRA_JA_VOTOU',         descricao: 'Não votante - ocupante anterior já proferiu voto nesta cadeira', codigo: 8, cor: red[900] },
    SEM_VOTO                 : { id: 'SEM_VOTO',                 descricao: 'Sem voto',           codigo: 99, cor: grey[300]  }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de tipos de voto.
 * @readonly
 */
class TipoVoto {
    static situacaoBase = new SituacaoIdDescricaoBase(TIPO_VOTO);
    static MSG_ERRO_IDENTIFICACAO_TIPO_VOTO = 'Não foi possível identificar o tipo do voto.';

    static getDescricao(id) {
        return TipoVoto.situacaoBase.getDescricao(id);
    }

    static getCodigo(id) {
        return TipoVoto.situacaoBase.getValorPropriedade(id, 'codigo');
    }

    static getDescricaoByCodigo(codigo) {
        const obj = TipoVoto.situacaoBase.getObjectByProperty('codigo', codigo);
        return obj ? TipoVoto.getDescricao(obj.id) : '';
    }

    static getCor(id) {
        return TipoVoto.situacaoBase.getValorPropriedade(id, 'cor');
    }

    static getCorByCodigo(codigo) {
        const obj = TipoVoto.situacaoBase.getObjectByProperty('codigo', codigo);
        return obj ? TipoVoto.getCor(obj.id) : SITUACAO_VOTO.SEM_VOTO.cor;
    }
}

export default TipoVoto;
